import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { createStationsPriceReport } from '../operations/createStationsPriceReport';

import { STATUS_LOADING } from 'common/constants';

export const setStationsPriceReportCreatingStatus = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(createStationsPriceReport.pending, (state) => {
    state.stationsPriceReport.creatingStatus = STATUS_LOADING.load;
  })
  .addCase(createStationsPriceReport.fulfilled, (state) => {
    state.stationsPriceReport.creatingStatus = STATUS_LOADING.done;
  })
  .addCase(createStationsPriceReport.rejected, (state) => {
    state.stationsPriceReport.creatingStatus = STATUS_LOADING.error;
  });
